import * as React from 'react';

import { VwbWorkspace } from 'generated/fetch';

import { FlexColumn, FlexRow } from 'app/components/flex';
import { SpinnerOverlay } from 'app/components/spinners';
import { VwbWorkspaceCard } from 'app/pages/workspace/vwb-workspace-card';

export type VwbWorkspaceCardModel = VwbWorkspace & {
  role?: 'OWNER' | 'WRITER' | 'READER';
  dataCollection?: string;
  lastChanged?: string;
  createdBy?: string;
};

interface Props {
  loading: boolean;
  workspaces: VwbWorkspaceCardModel[];
  currentUsername?: string;
}

export const VwbWorkspaces = ({
  loading,
  workspaces,
  currentUsername,
}: Props) => {
  if (loading) {
    return <SpinnerOverlay />;
  }

  return (
    <FlexColumn>
      <FlexRow style={{ alignItems: 'center' }}>
        <h2 style={{ fontWeight: 600, margin: 0 }}>Researcher Workbench</h2>
      </FlexRow>

      <FlexRow
        style={{
          marginTop: '1.5rem',
          flexWrap: 'wrap',
        }}
      >
        {workspaces.length === 0 ? (
          <div>No workspaces found</div>
        ) : (
          workspaces.map((workspace) => (
            <VwbWorkspaceCard
              key={workspace.id}
              workspace={workspace}
              currentUsername={currentUsername}
            />
          ))
        )}
      </FlexRow>
    </FlexColumn>
  );
};
